import Component from 'inferno-component';
import { Accordion, Container, Grid, Button, Transition } from 'semantic-ui-react';

const paragraphStyle = {
  fontSize: '1.1rem',
  textAlign: 'justify'
}

export default class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: -1
    }

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, titleProps) {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === -1 ? 0 : -1;

    this.setState({ activeIndex: newIndex });
  }

  render() {
    return (
      <Container fluid style={{backgroundColor: '#212121', marginLeft: '0 !important', marginRight: '0 !important'}} >
        <Container style={{padding: '50px 0 50px', color: '#F5F5F5'}} >
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Accordion>
                  <Accordion.Title
                    active={this.state.activeIndex === 0}
                    index={0}
                    style={{textAlign: 'center'}}>
                    <Button size='large' color='black' inverted onClick={this.handleClick}>
                      Ismerje meg cégünket és szolgáltatásunkat!
                    </Button>
                  </Accordion.Title>
                  <Transition visible={this.state.activeIndex === 0} animation='fade down' duration={500}>
                    <Accordion.Content active={this.state.activeIndex === 0} style={{marginTop: '2rem'}}>
                      <p style={paragraphStyle}>
                        Az UnivAdvert Kft. digitális hirdetési rendszere jelenleg már 11 hazai egyetem legforgalmasabb pontjain üzemel. Nagyméretű digitális hirdetőtábláink kihelyezése folyamatos, jelenlegi rendszerünk már több mint 140.000 hallgató elérésére nyújt lehetőséget. Kiépített rendszerünknek gyakorlatilag nincs meddőszórása, ráadásul impozáns, modern megjelenésű hirdetőtábláink elkerülhetetlen kontaktust teremtenek a hallgatósággal, ezáltal egy új típusú csatornán, az eddigi lehetőségekhez képest hatékonyabb módon reklámozhatnak Partnereink a célcsoport irányába. Professzionális szoftvereinkkel biztosítani tudjuk a megfelelő területi differenciálást, így speciális csomagokat kínálunk különböző hallgatói csoportok elérésére a megrendelői igényekhez igazítottan.
                      </p>
                      <p style={paragraphStyle}>
                        Digitális reklámozási rendszerünk létrehozásának egyik legfőbb célja az volt, hogy még az egyetemek falain belül, a munkaerőpiacra való kikerülés előtt kapcsolatot tudjunk teremteni a hallgatóság és a leendő munkáltatóik között. Egy valós, nehezen megoldható problémában, a magasan képzett, diplomás szakemberek korai megnyerésében szeretnénk közös munkával és rugalmas hozzáállással a HR szakemberek segítségére lenni, Emloyer Branding kampányaikban kiemelten részt venni. Erre rendszerünk kiválóan alkalmas, hiszen nagy felületen, mindig a figyelem középpontjában tudunk a hallgatóság számára digitális anyagokat megjeleníteni, mely anyagok kreatív kivitelezésével (animálás, videók) tovább lehet fokozni a látványt és a figyelemfelkeltő hatást.
                      </p>
                      <p style={paragraphStyle}>
                        Marketing szempontból nézve az egyetemista célcsoport a fogyasztói társadalom alakítójának és húzórétegének számító Y és Z-generáció egy olyan speciális rétege, melynek tagjai generációs társaikhoz képest a jövőben lényegesen nagyobb vásárlóerővel rendelkeznek, emellett trendérzékenységük és az új dolgok iránti befogadóképességük miatt jelenleg is kiemelt célcsoportnak számítanak. Ezen célcsoportot a leghatékonyabban elérve kiváló reklámozási és Brandépítési lehetőséget kínálunk Hirdetőpartnereink számára.
                      </p>
                      <p style={paragraphStyle}>
                        Fiatal, lendületes vezetésünk célja a HR és marketing szakemberek véleményét figyelembe véve rendszerünk folyamatos fejlesztése, kihelyezési helyszíneink bővítése és a hallgatói érdeklődés folyamatos fenntartása. 
                      </p>
                    </Accordion.Content>
                  </Transition>
                </Accordion>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about/About.js